/***
 * Created on 2023/7/12
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useRef, useState} from 'react';


function Dropdown(props) {
    const {data, children, initValue, ..._props} = props;
    const [showMenu, setShowMenu] = useState('');
    const [selectMenu, setSelectMenu] = useState('');
    const inputRef = useRef();

    const hideMenuHandler = (e) => {
        if (inputRef.current && !inputRef.current.contains(e.target)) {
            setShowMenu('');
        }
    }

    const toggleDropdown = (e) => {
        setShowMenu(prev => {
            return (prev === 'active') ? '' : 'active';
        });
    }

    const onClickEvent = (e, item) => {
        setSelectMenu(item);
        if (typeof props?.onClick === 'function') {
            props.onClick(e, item);
        }
    }

    useEffect(() => {
        window.addEventListener('click', hideMenuHandler);

        return () => {
            window.removeEventListener('click', hideMenuHandler);
        }
    });


    return (
        <div className={`comp-select ${showMenu}`} onClick={toggleDropdown} ref={inputRef}>
            <div className="q-select cursor-pointer">
                <div className="q-select__label">{selectMenu || initValue || ""}</div>
                <div className="q-select__arrow"></div>
            </div>
            <div className={`comp-dropdown ${_props.align === 'top' ? 'menu-align-top' : ''}`} data-modal-sheet>
                <ul className={`dropdown-menu`}>
                    {
                        children && children
                    }
                    {
                        data && data?.map(item => (
                            <li className="dropdown-menu__item cursor-pointer" key={item} onClick={e=>onClickEvent(e, item)}>{item}</li>
                        ))
                    }
                </ul>
            </div>
        </div>
    );
}

export default Dropdown;